var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"places-btn",on:{"click":function($event){return _vm.$emit('open')}}},[_c('icon-places',{attrs:{"color":"#7F66B6","height":"16","width":"12"}}),_c('div',[_vm._v("\n    "+_vm._s(_vm.$t("ourLocations"))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }